import { Meeting, MeetingPolitikerInfo, MeetingPendingInfo } from '../objects/Meeting';
import { MeetingLookupResult } from '../objects/MeetingLookupResult';
import { ResourceEndpoint } from './ResourceEndpoint';

/**
 * @typedef MeetingCmd
 * @type {object}
 * @property {Meeting} Meeting
 */

export class MeetingEndpoint extends ResourceEndpoint {
    constructor(url, api) {
        super(url, api, Meeting);
    }

    /**
     * @param {MeetingCmd} cmd
     */
    addMeeting(cmd) {
        if (!(cmd.Meeting instanceof Meeting)) {
            throw new TypeError('Invalid Argument');
        }

        let dst = this.url;
        return this._api.postResponse(dst, cmd)
            .then(rsp => rsp.createEntityResponse(this.resourceConstructor));
    }

    /**
     * @param {Meeting} obj
     */
    addEntity(obj) {
        return this.addMeeting({ Meeting: obj });
    }

    /**
     * @param {MeetingCmd} cmd
     */
    updateMeeting(cmd) {
        if (!(cmd.Meeting instanceof Meeting)) {
            throw new TypeError('Invalid Argument');
        }

        var dst = this.url + '/' + encodeURIComponent(cmd.Meeting.Id);
        return this._api.putResponse(dst, cmd)
            .then(rsp => rsp.createEntityResponse(this.resourceConstructor));
    }

    /**
     * @param {Meeting} obj
     */
    updateEntity(obj) {
        return this.updateMeeting({ Meeting: obj });
    }

    getMeetingsWithClaims(criteria) {
        var dst = this.url + '/claims';
        return this._api.postResponse(dst, criteria)
            .then(rsp => rsp.parseListResult(MeetingPolitikerInfo.mapResponse));
    }

    getMeetingsWithPending(criteria) {
        var dst = this.url + '/pending';
        return this._api.postResponse(dst, criteria)
            .then(rsp => rsp.parseListResult(MeetingPendingInfo.mapResponse));
    }

    getMessages(meetingId) {
        var dst = `${this.url}/${encodeURIComponent(meetingId)}/messages`;
        return this._api.getResponse(dst)
            .then(rsp => rsp.getResult());
    }

    addMessage(meetingId, msg) {
        var dst = `${this.url}/${encodeURIComponent(meetingId)}/messages`;
        return this._api.postVoid(dst, msg);
    }

    updateMessage(meetingId, msg) {
        var dst = `${this.url}/${encodeURIComponent(meetingId)}/messages/${encodeURIComponent(msg.Id)}`;
        return this._api.putVoid(dst, msg);
    }

    deleteMessage(meetingId, messageId) {
        var dst = `${this.url}/${encodeURIComponent(meetingId)}/messages/${encodeURIComponent(messageId)}/delete`;
        return this._api.postVoid(dst);
    }

    lookup(request) {
        var dst = this.url + '/lookup';
        return this._api.postResponse(dst, request)
            .then(rsp => rsp.parseListResult(x => new MeetingLookupResult(x)));
    }
}

